export const STORE_ADMIN_DE_MERGES = 'adminDeMerges';
export const ADMIN_DMS_SET_OPTIONS = 'setOptions';
